import gsap from "gsap";

const onBeforeEnter = (el) => {
    gsap.set(el, {
        scaleX:  0,
        scaleY:  0,
        opacity: 0
    })
}
const onEnter = (el, done) => {
    gsap.to(el, {
        duration:   1,
        scaleX:     1,
        scaleY:     1,
        opacity:    1,
        ease:       'elastic.inOut(1.2, 1)',
        onComplete: done
    })
}
const onLeave = (el, done) => {
    gsap.to(el, {
        duration:   0.2,
        scaleX:     1,
        y:          -50,
        opacity:    0,
        onComplete: done
    })
}

export {onBeforeEnter, onEnter, onLeave};